<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Apuração Mensal | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-12">
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Aplicativo: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.aplicativo ? registro.aplicativo.descricao : '-' }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Competência: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.competencia_ano + '/' + registro.competencia_mes }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
              <span class="label" v-bind:class="{
                  'label-success': registro.idc_status === 1,
                  'label-warning': registro.idc_status === 2,
                  'label-info': registro.idc_status === 3,
                  'label-danger': registro.idc_status === 4,
                  'label-default': registro.idc_status === 9
                }">{{ registro.status_desc }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Viagens Realizadas: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.viagens_realizadas ? registro.viagens_realizadas : '-' }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Viagens Apuradas: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.viagens_apuradas ? registro.viagens_apuradas : '-' }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Observações: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.observacao ? registro.observacao : '-' }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Criado em: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.created_at }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="motorista.nome">Motorista: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.motorista.nome }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="motorista.cpf">CPF Motorista: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.motorista.cpf }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="motorista.tel_celular">Telefone Motorista: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.motorista.tel_celular }}
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" class="btn btn-info" @click="abrirImagem()">Visualizar Imagem Perfil</button>
            <button type="button" class="btn btn-success" @click="avaliarPerfil()" v-show="registro.idc_status === 2">Validar</button>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-imagem" :adaptive="false" width="600" height="90%" style="top: 20px">
      <div class="modal-content">
          <button type="button" class="close" @click="$modal.hide('modal-imagem')" style="padding-right: 10px; padding-top: 5px;"><span aria-hidden="true">×</span></button>
          <b-img v-bind:src="`${imagemPerfil}`" fluid-grow class="center-block" style="height: -webkit-fill-available; padding: 5px;"></b-img>
      </div>
    </modal>

    <modal name="modal-motorista" :adaptive="true" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-motorista')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">{{ titleModal}}</h3>
        </div>
        <div class="modal-body" v-show="!isModalImagemPerfil">
					  <div v-show="errorMessageModal != ''" class="alert alert-danger">{{ errorMessageModal }}</div>

            <label for="historico">Observação <sup class="text-danger" v-show="!isModalPerfil">* </sup></label>
            <textarea id="historico" rows="4" v-model="historico" class="form-control" v-bind:class="{ 'box-input-required': errors.historico }"></textarea>
            <span v-show="errors.historico != null" class="help-inline">{{ errors.historico }}</span>
        </div>

        <div class="modal-body" v-show="isModalImagemPerfil">
          <img v-bind:src="`${imagemPerfil}`" />
        </div>

        <div class="modal-footer" v-show="!isModalImagemPerfil">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-motorista')">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="modalConfirma()" v-show="!isModalPerfil">Confirmar</button>

          <button type="button" class="btn btn-danger" @click="avaliarPerfilReprovar()" v-show="isModalPerfil">Reprovar</button>
          <button type="button" class="btn btn-success" @click="avaliarPerfilAprovar()" v-show="isModalPerfil">Aprovar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { formatCpf } from '@brazilian-utils/formatters'
import Formatters from '../../helpers/Formatters'
import ApuracaoMensalActions from '../../actions/ApuracaoMensalActions'
import moment from 'moment'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      titleModal: '',
      isModalPerfil: false,
      isModalImagemPerfil: false,
      imagemPerfil: '',
      historico: null,
      errorMessageModal: '',
      errors: {},
      registro: {
        cd_apuracao: '',
        cd_motorista: '',
        competencia_ano: '',
        competencia_mes: '',
        viagens_realizadas: '',
        viagens_apuradas: '',
        observacao: '',
        ext_imgem_perfil: '',
        idc_status: '',
        created_by: '',
        updated_by: '',
        created_at: '',
        updated_at: '',
        status_desc: '',
        imgem_perfil: '',
        motorista: {
          nome: '',
          cpf: '',
          tel_celular: ''
        },
        aplicativo: null
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    this.obterRegistro()
  },
  methods: {
    voltar () {
      this.$router.push((this.$route.query.ret_url ? this.$route.query.ret_url : '/apuracao-mensal'))
    },
    obterRegistro () {
      ApuracaoMensalActions.obterPorId(this.id)
        .then(res => {
          if (res && res.cd_apuracao) {
            this.registro = res

            this.registro.motorista.cpf = formatCpf(this.registro.motorista.cpf)
            this.registro.motorista.tel_celular = Formatters.formataNumeroTelefone(this.registro.motorista.tel_celular)

            if (this.registro.dt_agendada !== null) {
              this.registro.created_at = moment.utc(this.registro.created_at).format('DD/MM/YYYY')
            }
          } else {
            this.errorMessage = 'Registro não encontrado.'
          }
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Registro não encontrado.'
        })
    },
    abrirImagem () {
      this.titleModal = 'Imagem Perfil'
      this.isModalPerfil = false
      this.isModalImagemPerfil = true
      this.errorMessageModal = ''
      this.errors = {}
      this.imagemPerfil = ApuracaoMensalActions.getUrlImagem(this.registro.imgem_perfil)

      this.$modal.show('modal-imagem')
    },
    avaliarPerfil () {
      this.titleModal = 'Avaliar'
      this.isModalPerfil = true
      this.isModalImagemPerfil = false
      this.historico = ''
      this.errorMessageModal = ''
      this.errors = {}

      this.$modal.show('modal-motorista')
    },
    avaliarPerfilAprovar () {
      ApuracaoMensalActions.aprovar(this.id, this.historico)
        .then(res => {
          this.$modal.hide('modal-motorista')

          this.obterRegistro()
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessageModal = 'Ocorreu um erro ao gravar o registro.'
        })
    },
    avaliarPerfilReprovar () {
      ApuracaoMensalActions.reprovar(this.id, this.historico)
        .then(res => {
          this.$modal.hide('modal-motorista')

          this.obterRegistro()
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessageModal = 'Ocorreu um erro ao gravar o registro.'
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/apuracao-mensal/Detalhes.vue